import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Project } from '../../objects/Project';
import { ProjectService } from '../../Services/project.services';

@Component({
  selector: 'app-project-add',
  templateUrl: './project-add.component.html',
  styleUrls: ['./project-add.component.css']
})
export class ProjectAddComponent {

  form: FormGroup;
  isSubmitting = false;

  priorityOptions = [
    { value: 1, label: 'High' },
    { value: 2, label: 'Medium' },
    { value: 3, label: 'Low' },
  ];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private projectService: ProjectService,
    private snackBar: MatSnackBar
  ) {
    this.form = this.fb.group({
      title: ['', [Validators.required, Validators.maxLength(100)]],
      priority: [2, Validators.required],
      projectDescription: ['', [Validators.required, Validators.maxLength(1000)]],
    });
  }

  get descriptionLength(): number {
    return this.form.value.projectDescription?.length || 0;
  }

  selectPriority(value: number): void {
    this.form.patchValue({ priority: value });
  }

  onSubmit(): void {
    if (this.form.invalid || this.isSubmitting) {
      this.form.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;

    const newProject: Project = {
      id: 0,
      priority: this.form.value.priority,
      title: this.form.value.title,
      status: '',
      date: '',
      scheduledDate: '',
      scheduledTime: '',
      projectDescription: this.form.value.projectDescription,
      currentProjectPrice: 0,
      totalProjectPrice: 0,
      totalMaterialPrice: 0,
      totalLaborPrice: 0,
      projectBids: [],
      contractors: [],
      equipment: [],
      overhead: [],
      materials: [],
      fees: [],
      plans: [],
      projectImage: [],
      projectDrawing: [],
      projectTasks: [],
      userGuid: '',
    };

    this.projectService.addProject(newProject).subscribe({
      next: () => {
        this.snackBar.open('Project created successfully', '', { duration: 3000 });
        this.router.navigate(['/projects']);
      },
      error: () => {
        this.isSubmitting = false;
        this.snackBar.open('Something went wrong creating the project. Please try again.', '', { duration: 4000 });
      }
    });
  }

  cancel(): void {
    this.router.navigate(['/projects']);
  }
}
